import POIStep from "@/components/POI/POIStep/POIStep.vue";
import POITrailStateFields from "@/components/POI/POIStateFields/POITrailStateFields/POITrailStateFields.vue";

export default {
  components: { POIStep, POITrailStateFields },
  props: ["step", "position", "editedItem", "isOwnedBySubPrincipal"],
  methods: {
    changeStep(position) {
      this.$emit("changeStep", position);
    }
  }
};
